import React from 'react'
import Header from 'components/Header'
import UnsubscriptionCard from 'components/UnsubscriptionCard'
import Footer from 'components/Footer'
import { useSearchParams } from 'react-router-dom'

export default function Unsubscribe() {
  const [searchParams] = useSearchParams()
  return (
    <div
      style={{
        fontFamily: 'Open Sans',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Header app="unsubscribe" disableNavigation />
      <UnsubscriptionCard unsubscribeToken={searchParams.get('token')} />
      <Footer />
    </div>
  )
}
